var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-copy-content",class:{
    'input-copy-content_box': _vm.boxMode
  }},[_c('div',{ref:"valueContainer",staticClass:"input-copy-content__value truncate",class:{
    'input-copy-content__value_box': _vm.boxMode
  }},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"input-copy-content__copy-btn",on:{"click":_vm.copyToClipboard}},[_c('i',{staticClass:"far fa-copy",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }